import service from '@hybird/core/request'
import { useSealImages, SealStatus, SealImgType } from '@/store/seal'
import { reactive } from 'vue'
import { uploadManager } from '@hybird/device/request'
import { xda, isSupport } from '@hybird/flutter'

export const backgroundUploadFile = (data, url, config = {}) => {
  // 关键：不要把 fileData 原样透传给 uploadFile
  // uploadFile 内部会基于 fileData 生成 upload 字段 `file`，
  // 如果 formData 里还包含 fileData，flutter 的适配层可能会把它当作第二个“文件字段”，从而触发重复上传。
  const { fileData, ...formData } = data || {}
  // throw 'errr'
  return service.uploadFile(
    fileData,
    url,
    config,
    formData,
    false
  )
}

export const backgroundRequest = (params) => {
   return service(params)
}


export default function useSealImageUpload() {
  // 用印图片库
  const sealImagesStore = useSealImages()

  const beginUpload = async (data, url, sealImgType) => {

    const imageId = sealImagesStore.addImage(data, sealImgType)

    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}

    const res = await uploadManager.backgroundUploadFile({ userNo: userInfo.userId || Date.now(), notCacheFile: !isSupport(), isNotRestart: true }, data, url, {
      onUploadProgress: (progressEvent) => {
        console.log('上传进度', progressEvent)
        const event = progressEvent.event || progressEvent
        if (sealImagesStore.sealImagesMap[imageId]) {
          sealImagesStore.sealImagesMap[imageId].progress =
            (1 / event.total) * event.loaded
          if (event.loaded >= event.total) {
            sealImagesStore.sealImagesMap[imageId].status = SealStatus.complete
          }
        }
      }
    })
    console.log('beginUpload', typeof res == 'object' ?  JSON.stringify(res) : res)
    if (res && res.success) {
      if (sealImagesStore.sealImagesMap[imageId]) {
        sealImagesStore.sealImagesMap[imageId].status = SealStatus.complete

        // 矫正之后的图片
        if(res.data.fullFile){
          sealImagesStore.sealImagesMap[imageId].path = res.data.fullFile
        }
      }
    } else {
      sealImagesStore.sealImagesMap[imageId].status = SealStatus.fail
    }

    return res
  }

  const syncScannerImg = async (data, url) => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    return uploadManager.backgroundRequest({ userNo: userInfo.userId || Date.now(), notCacheFile: true, isNotRestart: true }, { method: 'PUT', data, url})
  }

  return {
    backgroundUploadFile,
    beginUpload,
    syncScannerImg
  }
}